import { render, staticRenderFns } from "./resultRecording.vue?vue&type=template&id=060847b3&scoped=true"
import script from "./resultRecording.vue?vue&type=script&lang=js"
export * from "./resultRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060847b3",
  null
  
)

export default component.exports